// extracted by mini-css-extract-plugin
export default {"imgBolo":"Image_imgBolo__9xy4W"};